import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core/';
import { connect } from 'react-redux';
import { showNotification, refreshView } from 'react-admin';
import { DotsIcon } from './icons/Dots';
import { withStyles } from '@material-ui/core/styles';
import formats from '../../../../../constants/formats';
import { linkToRecord } from 'ra-core';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../services/date';
import { withRouter } from 'react-router-dom';
import { httpClient } from '../../../../../provider/dataProvider';

const styles = () => ({
  paper: {
    maxHeight: '33.3vh',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 8px 0px rgba(178, 199, 224, 0.40)',
    borderRadius: 4,
    backgroundColor: '#fff',
    minWidth: 200,
    '& ul': {
      padding: 0,
      '& > *': {
        boxSizing: 'border-box',
        position: 'relative',
        minHeight: 44,
        padding: 12,
        fontFamily: 'Public Sans',
        fontSize: 14,
        lineHeight: '20px',
        color: '#404040',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        '&:hover': {
          backgroundColor: '#F0F3F5',
          color: '#404040',
        },
      },
    },
  },
  icon: {
    width: 20,
    height: 20,
    color: '#525252',
  },
});

const Component = ({ classes, record, showNotification, basePath, refreshView, history }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleCancel = async (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    const deliveryDate = formatDate(record.deliveryDate, formats.DELIVERY_DATE);
    const payload = {
      id: record.id,
      approved: record.approved,
      customerId: record.customerId,
      currencyId: record.currencyId,
      deliveryDate: deliveryDate,
      deliveryAddress: record.deliveryAddress,
      timeDate: record.timeDate,
      netTotal: record.netTotal,
      dispatched: record.dispatched,
      hhEditState: record.hhEditState,
      orderFilled: true,
      sentToScales: record.sentToScales,
      currency: record.currency,
      saleOrderItems: [] || null,
      Exported: 4,
    };

    await httpClient(`/api/SaleOrder/${record.id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    })
      .then(() => {
        showNotification('Sale Order canceled successfully.', 'info');
        refreshView();
      })
      .catch(error => {
        showNotification(`Error canceling Sale Order: ${error.message}`, 'warning');
      });
  };

  const handleReOrder = (e) => {
    e.stopPropagation();
    localStorage.setItem("cloneId", record.id);
    history.push(`${basePath}/create`);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <DotsIcon className={classes.icon} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} classes={{ paper: classes.paper }}>
        <MenuItem onClick={handleReOrder}>
          Re-Order
        </MenuItem>
        <MenuItem onClick={handleCancel} disabled={record.exported === 1 || record.exported === 3 || record.exported === 4}>
          Cancel
        </MenuItem>
      </Menu >
    </>
  );
};

export const UiTableActions = withRouter(connect(null, {
  showNotification,
  refreshView,
})(withStyles(styles)(Component)));
